
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormItem } from "@/components/ui/form";
import { MapPin, Home, Building, MapIcon } from "lucide-react";

interface ProfileFormAddressProps {
  formData: {
    endereco: string;
    cidade: string;
    estado: string;
    cep: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const ProfileFormAddress = ({ formData, handleChange }: ProfileFormAddressProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="bg-gradient-to-r from-hero-blue/10 to-hero-green/10 p-4 rounded-md border border-hero-blue/20 mb-6">
        <div className="flex items-start gap-3">
          <MapPin className="h-5 w-5 text-hero-blue mt-0.5" />
          <div>
            <h3 className="text-sm font-medium text-hero-blue-dark">Endereço</h3>
            <p className="text-sm text-gray-700 mt-1">
              Mantenha seu endereço atualizado para facilitar a comunicação e o envio de documentos.
            </p>
          </div>
        </div>
      </div>

      <FormItem className="space-y-2">
        <Label htmlFor="endereco" className="text-gray-700 font-medium flex items-center gap-2">
          <Home className="h-4 w-4 text-hero-blue" />
          Endereço Completo
        </Label>
        <Input 
          id="endereco" 
          value={formData.endereco} 
          onChange={handleChange}
          className="border border-gray-300 focus:border-hero-blue focus:ring focus:ring-hero-blue/20" 
          placeholder="Rua, número, complemento" 
        />
      </FormItem>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormItem className="space-y-2">
          <Label htmlFor="cidade" className="text-gray-700 font-medium flex items-center gap-2">
            <Building className="h-4 w-4 text-hero-blue" />
            Cidade
          </Label>
          <Input 
            id="cidade" 
            value={formData.cidade} 
            onChange={handleChange}
            className="border border-gray-300 focus:border-hero-blue focus:ring focus:ring-hero-blue/20" 
            placeholder="Sua cidade"
          />
        </FormItem>
        <FormItem className="space-y-2">
          <Label htmlFor="estado" className="text-gray-700 font-medium flex items-center gap-2">
            <MapIcon className="h-4 w-4 text-hero-blue" />
            Estado
          </Label>
          <Input 
            id="estado" 
            value={formData.estado} 
            onChange={handleChange}
            className="border border-gray-300 focus:border-hero-blue focus:ring focus:ring-hero-blue/20" 
            placeholder="UF"
          />
        </FormItem>
        <FormItem className="space-y-2">
          <Label htmlFor="cep" className="text-gray-700 font-medium">CEP</Label>
          <Input 
            id="cep" 
            value={formData.cep} 
            onChange={handleChange}
            className="border border-gray-300 focus:border-hero-blue focus:ring focus:ring-hero-blue/20" 
            placeholder="00000-000" 
          />
        </FormItem>
      </div>
    </div>
  );
};
